export const defaultProactiveChatPaneTitleStyles = {
  color: "rgb(255, 255, 255)",
  fontFamily: "'Segoe UI', Arial, sans-serif"
};